<template>
  <InputTableContainer
    :loading="$apollo.loading"
    :headers="headers"
    :data="data"
    :actions="actions"
    :sortBy="sortBy"
    :sortDesc="sortDesc"
    type="trainDeviation"
  >
    <template v-slot:toolbar-right>
      <TrainDeviationCreateDropdown />
    </template>
  </InputTableContainer>
</template>

<script>
import { get } from 'vuex-pathify'
import InputTableContainer from '@/components/InputTableContainer'
import { format } from 'date-fns'
import trainDeviationTypes from '@/common/trainDeviationTypes'
import TrainDeviationCreateDropdown from './TrainDeviationCreateDropdown'
import TrainDeviationEditModal from './TrainDeviationEditModal'
import TrainDeviationDeleteModal from './TrainDeviationDeleteModal'

export default {
  name: 'TrainDeviationContainer',

  components: {
    InputTableContainer,
    TrainDeviationCreateDropdown
  },

  data: () => ({
    actions: [
      {
        title: 'Redigera',
        icon: 'mdi-pencil',
        component: TrainDeviationEditModal,
        type: 'edit'
      },
      {
        title: 'Ta bort',
        icon: 'mdi-delete',
        component: TrainDeviationDeleteModal,
        type: 'delete'
      }
    ],
    sortDesc: false,
    sortBy: ['_departure'],
    headers: [
      {
        text: 'Avvikelse',
        value: '_deviation_type'
      },
      {
        text: 'Typ',
        value: 'type'
      },
      {
        text: 'Tågnr.',
        value: 'train_number'
      },
      {
        text: 'Från',
        value: '_from'
      },
      {
        text: 'Till',
        value: '_to'
      },
      {
        text: 'Avg.',
        value: '_departure'
      },
      {
        text: 'Ank.',
        value: '_arrival'
      },
      {
        text: '',
        value: 'actions',
        sortable: false,
        filterable: false,
        align: 'right'
      }
    ]
  }),

  computed: {
    trainDeviations: get('trainDeviation/data'),
    stops: get('event/stops'),

    data() {
      const findLocationName = signature => {
        const location = this.stops.find(
          x => x.short_name === signature.toUpperCase()
        )
        return location ? location.stop_name : signature.toUpperCase()
      }
      return Object.values(this.trainDeviations)
        .filter(x => x.deviation_type !== 'CANCELED_STOP')
        .map(x => {
          return {
            ...x,
            _from: findLocationName(x.from),
            _to: findLocationName(x.to),
            _deviation_type: trainDeviationTypes[x.deviation_type],
            _departure: format(new Date(x.departure), 'yyyy-MM-dd HH:mm'),
            _arrival: format(new Date(x.arrival), 'HH:mm')
          }
        })
    }
  },

  watch: {
    trainDeviations() {
      this.$store.dispatch('duaMessage/setForm')
      this.$store.dispatch('smsMessage/setForm')
    }
  },

  beforeDestroy() {
    this.$store.set('trainDeviation/data', {})
  }
}
</script>
